module.exports = __webpack_public_path__ + "6c7c965bc3cfface62af439c3eddd760.fbx";